const CloseIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
    >
      <path
        fill="#000099"
        d="M14.177 3l2.121 2.121L11.77 9.65l4.528 4.528-2.121 2.121-4.528-4.528-4.528 4.528L3 14.177l4.527-4.528L3 5.121 5.121 3 9.65 7.527z"
        fillRule="evenodd"
      ></path>
    </svg>
  );
};

export default CloseIcon;
